import type { ReactNode } from "react";
import { cx } from "../ui/cx";
import { Icon, type IconName } from "../ui/Icon";

/**
 * Their own thumbnail, or a drawn tile when there is none (`.k-fr`), never an empty grey hole. `size` is a row's 92 px,
 * a small 68 px, or the full width; `badge` sits at the top left and `duration` at the bottom right.
 */
export function Picture({
  src,
  size = "row",
  shape = "wide",
  fallback = "play",
  badge,
  duration,
  className,
}: {
  src?: string | null;
  size?: "row" | "sm" | "lg";
  shape?: "wide" | "tall" | "sq";
  fallback?: IconName;
  badge?: ReactNode;
  duration?: string;
  className?: string;
}) {
  return (
    <span className={cx("k-fr", `k-fr-${size}`, shape === "tall" && "tall", shape === "sq" && "sq", className)}>
      {src ? <img src={src} alt="" /> : <Icon name={fallback} />}
      {badge ? <span className="k-ov">{badge}</span> : null}
      {duration ? <span className="k-dur">{duration}</span> : null}
    </span>
  );
}
